<template>
  <div class="teams">
    <Hero :image="currentTeam.cover" layout="half" :title="'<strong>'+ (subTeamName || teamName) +'</strong>'"/>

    <!-- Quando o time atual tem sub-times, exibimos eles... Caso contrário, podemos exibir a página de time -->

    <ListSubTeams v-if="hasSub" :team="currentTeam"/>
    <TeamPage v-if="!hasSub" :team="currentTeam"/>
  </div>
</template>

<script>
import Hero from "@/components/media/Hero.vue";
import TeamPage from "@/views/Teams/TeamPage";
import ListSubTeams from "@/views/Teams/ListSubTeams";
import Gallery from "@/components/media/Gallery.vue";


export default {
  name: "Teams",
  
  props: {
    teamName: String,
    subTeamName: String
  },

  head(){
    return this.$head({
      title: "",
    });
  },

  components: {
    Hero,
    TeamPage,
    ListSubTeams,
    Gallery
  },

  computed: {

    currentTeam() {
      if (this.subTeamName) {
        const team = this.$store.state.teams.find(
          t => t.title === this.teamName
        );
        const subTeam = team.sub.find(st => st.title === this.subTeamName);
        return subTeam;
      } else {
        const team = this.$store.state.teams.find(
          t => t.title === this.teamName
        );
        return team;
      }
    },

    hasSub() {
      if (this.currentTeam.sub) {
        return true;
      } else {
        return false;
      }
    }
  }
};
</script>

<style lang="scss"></style>